<div class="wiki-view-article">
  @if (isLoading()) {
    <div class="oph-loading-container">
      <oph-loading></oph-loading>
    </div>
  } @else {
    @if (wikiItem$ | async; as wikiItem) {
      <div class="wiki-view-article-container">
        <h1 class="wiki-view-article__title">
          {{ wikiItem.title }}
        </h1>
        <h4>Author: {{ wikiItem.author }}</h4>
        <quill-view [content]="wikiItem.content" />
      </div>
    }

    <div class="wiki-view-article__footer">
      <oph-dialog-footer [labels]="footerActionLabels()" [loading]="false" [hideMenu]="true" (save)="onSave()" />
    </div>
  }
</div>
